export const environment = {
  production: true,
  appName: 'PSA_DEV'
};
